import { createVNode as _createVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"
import _imports_0 from '@/assets/media/avatars/150-11.jpg'
import _imports_1 from '@/assets/media/avatars/150-3.jpg'
import _imports_2 from '@/assets/media/avatars/150-5.jpg'


const _hoisted_1 = { class: "timeline-item" }
const _hoisted_2 = /*#__PURE__*/_createVNode("div", { class: "timeline-line w-40px" }, null, -1)
const _hoisted_3 = { class: "timeline-icon symbol symbol-circle symbol-40px me-4" }
const _hoisted_4 = { class: "symbol-label bg-light" }
const _hoisted_5 = { class: "svg-icon svg-icon-2 svg-icon-gray-500" }
const _hoisted_6 = /*#__PURE__*/_createVNode("div", { class: "timeline-content mb-10 mt-n1" }, [
  /*#__PURE__*/_createVNode("div", { class: "pe-3 mb-5" }, [
    /*#__PURE__*/_createVNode("div", { class: "fs-5 fw-bold mb-2" }, " There are 2 new tasks for you in “AirPlus Mobile APp” project: "),
    /*#__PURE__*/_createVNode("div", { class: "d-flex align-items-center mt-1 fs-6" }, [
      /*#__PURE__*/_createVNode("div", { class: "text-muted me-2 fs-7" }, "Added at 4:23 PM by"),
      /*#__PURE__*/_createVNode("div", {
        class: "symbol symbol-circle symbol-25px",
        "data-bs-toggle": "tooltip",
        "data-bs-boundary": "window",
        "data-bs-placement": "top",
        title: "Nina Nilson"
      }, [
        /*#__PURE__*/_createVNode("img", {
          src: _imports_0,
          alt: "img"
        })
      ])
    ])
  ]),
  /*#__PURE__*/_createVNode("div", { class: "overflow-auto pb-5" }, [
    /*#__PURE__*/_createVNode("div", { class: "d-flex align-items-center border border-dashed border-gray-300 rounded min-w-750px px-7 py-3 mb-5" }, [
      /*#__PURE__*/_createVNode("a", {
        href: "#",
        class: "fs-5 text-dark text-hover-primary fw-bold w-375px min-w-200px"
      }, "Meeting with customer"),
      /*#__PURE__*/_createVNode("div", { class: "min-w-175px pe-2" }, [
        /*#__PURE__*/_createVNode("span", { class: "badge badge-light text-muted" }, "Application Design")
      ]),
      /*#__PURE__*/_createVNode("div", { class: "symbol-group symbol-hover flex-nowrap flex-grow-1 min-w-100px pe-2" }, [
        /*#__PURE__*/_createVNode("div", { class: "symbol symbol-circle symbol-25px" }, [
          /*#__PURE__*/_createVNode("img", {
            src: _imports_1,
            alt: "img"
          })
        ]),
        /*#__PURE__*/_createVNode("div", { class: "symbol symbol-circle symbol-25px" }, [
          /*#__PURE__*/_createVNode("img", {
            src: _imports_0,
            alt: "img"
          })
        ]),
        /*#__PURE__*/_createVNode("div", { class: "symbol symbol-circle symbol-25px" }, [
          /*#__PURE__*/_createVNode("div", { class: "symbol-label fs-8 fw-bold bg-primary text-inverse-primary" }, " A ")
        ])
      ]),
      /*#__PURE__*/_createVNode("div", { class: "min-w-125px pe-2" }, [
        /*#__PURE__*/_createVNode("span", { class: "badge badge-light-primary" }, "In Progress")
      ]),
      /*#__PURE__*/_createVNode("a", {
        href: "#",
        class: "btn btn-sm btn-light btn-active-light-primary"
      }, "View")
    ]),
    /*#__PURE__*/_createVNode("div", { class: "d-flex align-items-center border border-dashed border-gray-300 rounded min-w-750px px-7 py-3 mb-0" }, [
      /*#__PURE__*/_createVNode("a", {
        href: "#",
        class: "fs-5 text-dark text-hover-primary fw-bold w-375px min-w-200px"
      }, "Project Delivery Preparation"),
      /*#__PURE__*/_createVNode("div", { class: "min-w-175px" }, [
        /*#__PURE__*/_createVNode("span", { class: "badge badge-light text-muted" }, "CRM System Development")
      ]),
      /*#__PURE__*/_createVNode("div", { class: "symbol-group symbol-hover flex-nowrap flex-grow-1 min-w-100px" }, [
        /*#__PURE__*/_createVNode("div", { class: "symbol symbol-circle symbol-25px" }, [
          /*#__PURE__*/_createVNode("img", {
            src: _imports_2,
            alt: "img"
          })
        ]),
        /*#__PURE__*/_createVNode("div", { class: "symbol symbol-circle symbol-25px" }, [
          /*#__PURE__*/_createVNode("div", { class: "symbol-label fs-8 fw-bold bg-success text-inverse-primary" }, " B ")
        ])
      ]),
      /*#__PURE__*/_createVNode("div", { class: "min-w-125px" }, [
        /*#__PURE__*/_createVNode("span", { class: "badge badge-light-success" }, "Completed")
      ]),
      /*#__PURE__*/_createVNode("a", {
        href: "#",
        class: "btn btn-sm btn-light btn-active-light-primary"
      }, "View")
    ])
  ])
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg = _resolveComponent("inline-svg")!

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _hoisted_2,
    _createVNode("div", _hoisted_3, [
      _createVNode("div", _hoisted_4, [
        _createVNode("span", _hoisted_5, [
          _createVNode(_component_inline_svg, { src: "@/assets/media/icons/duotone/Communication/Chat2.svg" })
        ])
      ])
    ]),
    _hoisted_6
  ]))
}